import React from 'react';
interface CtaButtonProps {
  children: React.ReactNode;
  variant?: 'lime' | 'magenta';
  className?: string;
  href?: string;
  onClick?: () => void;
}
export function CtaButton({
  children,
  variant = 'lime',
  className = '',
  href,
  onClick
}: CtaButtonProps) {
  const base = 'inline-flex items-center justify-center rounded-full px-8 py-4 text-base font-extrabold uppercase tracking-wide transition-[transform,background-color,color] duration-150 hover:scale-[1.02] active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-aqua focus-visible:ring-offset-2 focus-visible:ring-offset-ink sm:text-lg';
  const styles = variant === 'lime' ? 'bg-lime text-ink hover:bg-magenta hover:text-white' : 'bg-magenta text-white hover:bg-lime hover:text-ink';
  if (href) {
    return <a href={href} className={`${base} ${styles} ${className}`} data-id="element-14" data-mp="19bl2l8m9eqex">
        {children}
      </a>;
  }
  return <button type="button" onClick={onClick} className={`${base} ${styles} ${className}`} data-id="element-15" data-mp="157ddhabw38g6">
      {children}
    </button>;
}